import { Link } from "qw-ui-lib-v2";
import { renderRouterLink } from "../../utils/routerLink";
import PageNotFoundSvg from "../../assets/icons/PageNotFound.svg";

export default function PageNotFound() {
  return (
    <div className="page-error">
      <PageNotFoundSvg className="page-error__illustration" />
      <h1 className="page-error__title">Page Not Found</h1>
      <p className="page-error__message">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Link variant="primary" href="/" render={renderRouterLink}>
        Go Home
      </Link>
    </div>
  );
}
